/**
 * <SlotChips> — la liste de ce que le parent a choisi, en chips (privé au récapitulatif).
 *
 * Un seul appelant, `<ExtraHoursRecapStep>` : il l'utilise pour les créneaux cochés comme pour
 * les dates demandées, qui se lisent de la même façon. Le composant ne compose rien — les
 * libellés arrivent écrits — il ne fait que les poser et les laisser passer à la ligne.
 */
import React from "react"
import { View } from "react-native"
import { StyleSheet } from "react-native-unistyles"

import { Badge } from "../../atoms/Badge"
import { Text } from "../../atoms/typography/Text"

export type SlotChipsProps = {
    labels: string[]
    /** Ce qu'on dit quand rien n'est choisi. */
    emptyMessage: string
    testID?: string
}

export function SlotChips(props: SlotChipsProps) {
    const { labels, emptyMessage, testID } = props

    if (labels.length === 0) {
        return (
            <Text size="text-md" color="text-muted" testID={testID}>
                {emptyMessage}
            </Text>
        )
    }

    return (
        <View style={styles.wrap} testID={testID}>
            {labels.map((label) => (
                <Badge key={label} text={label} variant="primary" tinted iconName="check" />
            ))}
        </View>
    )
}

const styles = StyleSheet.create((theme) => ({
    wrap: {
        flexDirection: "row",
        flexWrap: "wrap",
        gap: theme.spacing["2"],
    },
}))
